var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"girl",staticClass:"girl"},[_c('img',{ref:"girlImg",attrs:{"src":require("@/assets/img/girl_modern.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }